import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class WorkInfo extends ModelMixin() implements Model<WorkInfo> {

    TYPE = WorkInfo;
    static projectionInformation = new ProjectionInformation('workInfo');

    public ableToWorkLegallyInUSA: boolean;
    public permissionType: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/work-info.model.ts